import { OutTable, ExcelRenderer } from "react-excel-renderer";
import XLSX from "xlsx";

// import {import_keys} from '../utils/setting'
const exportExcel = {
  state: {
    import_excel: {},
    import_json: {}
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    }
  },
  effects: dispatch => ({
    exportExcel(payload = {}, rootState) {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(payload.exportData);
      const wb = XLSX.utils.book_new();

      ws["A1"].s = {
        fill: {
          patternType: "solid",
          bgColor: {
            rgb: "003d79"
          },
          fgColor: {
            rgb: "003d79"
          }
        },
        font: {
          name: "Times New Roman",
          sz: 16,
          color: { rgb: "#FF000000" },
          bold: true,
          italic: false,
          underline: false
        }
      };

      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: payload.length || 10 } }
      ];
      XLSX.utils.book_append_sheet(wb, ws, payload.sheet || "SheetJS");
      /* generate XLSX file and send to client */
      XLSX.writeFile(wb, `${payload.name}.xlsx`);
    },
    importExcel(payload = {}, rootState) {
      // let resp = rootState.exportExcel.import_excel;
      // if(payload.resp) {
      //     resp = payload.resp;
      // }
      // let rows = resp.rows;
      // // let cols = resp.cols;
      // if(rows) {
      //     let keys = {}, title = {}, datas = [];
      //     datas = rows.filter(e => {
      //         if(e && e.length) {
      //             if(e[0] === '#') {
      //                 delete e[0];
      //                 keys = e
      //             }
      //             else if(e[0] === '//') {
      //                 delete e[0];
      //                 title = e;
      //             }
      //             else {
      //                 delete e[0]
      //                 return e
      //             }
      //         }
      //     })
      //     let json = [];
      //     let elem = {};
      //     let key = ''
      //     datas.forEach((data, i) => {
      //         elem = {}
      //         data.forEach((e, i2) => {
      //             key = keys[i2];
      //             if(import_keys.find(e => e === key)) {
      //                 elem[key] = e;
      //             }
      //             else {
      //                 key = (title[i2] || '').trim();
      //                 if(key) {
      //                     elem.extraData = elem.extraData || [];
      //                     elem.extraData.push({
      //                         [key]: e
      //                     })
      //                 }
      //             }
      //         })
      //         if(elem && Object.keys(elem).length) json.push(elem)
      //     })
      //     this.setState({import_json: json})
      // }
      // else {
      //     if(payload.toastr) payload.toastr("Fail", 'Pls, choose excel file', 'error')
      // }
      // return true;
    },
    chooseExcel(payload = {}, rootState) {
      ExcelRenderer(payload.file, (err, resp) => {
        if (err) {
          console.log(err);
        } else {
          let rows = resp.rows;
          let cols = resp.cols;
          this.setState({ import_excel: { rows: rows, cols: cols } });
        }
      });
    }
  })
};

export default exportExcel;
